import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { SignalRService } from '../../services/signal-r.service';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  messageError: any;
  model: any = {};
  returnUrl: string;
  isSubmitted: any = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    ) { }

  ngOnInit() {
    this.loginService.logout();
    console.log('componente del loginerss');
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home/dashboard/';
    $('body').addClass('empty-layout');

  }

  login(): void {
    this.loading = true;
    this.loginService.login(this.model.username, this.model.password)
      .then(data => {
        if ( data && data['status'] && data['status'] === 'EXITO' ) {
          this.router.navigate([this.returnUrl]);
          // window.location.href = this.returnUrl;
          // window.location.href = '/index.html';
        } else {
          this.messageError = data['message'];
        }
      })
      .catch(error => {
        console.log('login.component.error', error);
        this.loading = false;
      });
  }

















  // ngAfterViewInit() {
  //   $('#login-form').validate({
  //     errorClass: 'help-block',
  //     rules: {
  //       email: {required: true, email: true},
  //       password: {required: true}
  //     },
  //     highlight: function(e){$(e).closest('.form-group').addClass('has-error')},
  //     unhighlight: function(e){$(e).closest('.form-group').removeClass('has-error')},
  //   });
  // }
  //
  // ngOnDestroy() {
  //   $('body').removeClass('empty-layout');
  // }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/login/login.component.ts